module.exports = __webpack_public_path__ + "static/img/logo-max.ff29e2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-max.png
// module id = l/0a
// module chunks = 152